module.exports = __webpack_public_path__ + "static/media/55_000010.1037d337.jpg";